import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import HowItWorks from './components/HowItWorks';
import ComparisonTable from './components/ComparisonTable';
import SeoPreview from './components/SeoPreview';
import SafetySection from './components/SafetySection';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Kakobuy Spreadsheet Polska – Najlepsza Lista Produktów i Przewodnik Zakupów 2026',
    description:
      'Kakobuy Spreadsheet Polska 2026 – kompletny przewodnik zakupowy z gotowymi listami produktów, kategoriami, poradnikami bezpieczeństwa i aktualnymi informacjami dla użytkowników z Polski.',
    url: `${siteUrl}/`,
    inLanguage: 'pl',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Kakobuy Polska',
      url: siteUrl,
    },
    about: {
      '@type': 'Thing',
      name: 'Kakobuy Spreadsheet',
      description:
        'Kakobuy Spreadsheet to gotowa lista produktów dostępnych przez platformę Kakobuy, zawierająca setki produktów w różnych kategoriach.',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Co to jest Kakobuy Spreadsheet?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Kakobuy Spreadsheet to gotowa, uporządkowana lista produktów dostępnych przez platformę Kakobuy. Zawiera setki starannie wyselekcjonowanych produktów pogrupowanych w kategorie takie jak buty, odzież, akcesoria i wiele więcej. To najszybszy sposób na znalezienie sprawdzonych produktów z Chin bez konieczności samodzielnego przeszukiwania tysięcy ofert.',
        },
      },
      {
        '@type': 'Question',
        name: 'Czy Kakobuy Spreadsheet jest darmowy?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Tak, Kakobuy Spreadsheet jest całkowicie darmowy. Możesz przeglądać listy produktów, kategorie i korzystać ze wszystkich linków bez żadnych opłat.',
        },
      },
      {
        '@type': 'Question',
        name: 'Czy Kakobuy wysyła do Polski?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Tak, Kakobuy oferuje wysyłkę do Polski. Dostępnych jest kilka metod dostawy o różnym czasie realizacji i koszcie. Paczki są śledzone, a w razie potrzeby możesz wykupić dodatkowe ubezpieczenie przesyłki.',
        },
      },
      {
        '@type': 'Question',
        name: 'Jak często aktualizowane są listy produktów?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Listy produktów w Kakobuy Spreadsheet są regularnie aktualizowane, aby zapewnić dostęp do najnowszych i najlepszych ofert. Produkty, które są niedostępne, są usuwane, a nowe, popularne pozycje są dodawane na bieżąco.',
        },
      },
    ],
  };

  return (
      <div className="min-h-screen bg-background-50">
        <header>
          <Navbar />
        </header>

        <main>
          <Hero />
          <CategoryGrid />
          <HowItWorks />
          <ComparisonTable />
          <SeoPreview />
          <SafetySection />
          <FAQ />
          <CTASection />
        </main>

        <Footer />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
      </div>
  );
}